<template>
  <div class="wrap-carousel">
    <b-carousel
      indicators
    >
      <b-carousel-slide
        v-for="(banner, i) in banners"
        :key="i"
      >
        <template v-slot:img>
          <img
            :src="`https://admanawards.com/storage/app/img/banner/${banner.banner_picture}`"
            data-loading="xxx.jpg"
            style="width: 100vw;"
          >
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      banners: state => state.banner.data
    })
  },

  methods: {
    getBannerApi () {
      const routeName = this.$route.name

      if (!this.banners) {
        this.$store.dispatch('banner/get', routeName)
      }
    }
  },

  created () {
    this.getBannerApi()
  }
}
</script>

<style lang="scss" scoped>
.wrap-carousel {
  width: 100vw;
}
</style>
